'use strict';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../../../components/buttons/Button';
import {StatefulButton} from '../../../../components/buttons/StatefulButton';
import {Modal} from '../../../../components/modals/Modal';
import {ModalContent} from '../../../../components/modals/ModalContent';
import {ModalFooter} from '../../../../components/modals/ModalFooter';
import {ModalHeader} from '../../../../components/modals/ModalHeader';
import {StatusOverlayComponent} from '../../../../core-components/loading-icon/components/StatusOverlayComponent';
import {ButtonState} from '../../../enums/ButtonState';
import {RequestStatus} from '../../../enums/RequestStatus';
import {ViewMode} from '../../../enums/ViewMode';
import {I18nComponent} from '../../../react-i18n/I18nComponent';
import {requestToButtonState} from '../../../redux-request/utils';


const successLabel = 'Downloading Report';
const loadingLabel = 'Creating Report';
const noDataLabel = 'Report is Empty';
const errorLabel = 'Something went wrong';

function renderMessage(props) {
  let mode;
  switch (props.status) {
    case RequestStatus.PENDING:
      return null;

    case RequestStatus.IS_FETCHING:
      mode = ViewMode.LOADING;
      break;

    case RequestStatus.SUCCESS:
      mode = ViewMode.SUCCESS;
      break;

    case RequestStatus.NO_RESULTS:
      mode = ViewMode.NO_DATA;
      break;

    case RequestStatus.ERROR:
      mode = ViewMode.EOTHER;
      break;
  }

  return (
    <div className="ExportModal__overlay">
      <StatusOverlayComponent
        mode={mode}
        showSuccess={true}
        successLabel={successLabel}
        loadingLabel={loadingLabel}
        noDataLabel={noDataLabel}
        errorLabel={errorLabel}
      />
    </div>
  );
}

export function BaseExportModalHOCView(props) {
  const mode = requestToButtonState(props);
  return (
    <Modal className={props.className}>
      <ModalHeader modalHeaderLabel={props.headerLabel} />
      <ModalContent className="ExportModal">

        {renderMessage(props)}

        {props.children}
      </ModalContent>
      <ModalFooter>
        <Button
          className="FormModal__cancelButton"
          disabled={mode !== ButtonState.START}
          label={props.cancelLabel}
          onClick={props.onCancel}
        />
        <Button
          className="FormModal__cancelButton"
          disabled={mode !== ButtonState.START}
          label={props.resetButtonLabel}
          onClick={props.onReset}
        />
        <StatefulButton
          buttonClassName="FormModal__saveButton"
          startClassName="FormModal__saveButton_start"
          frontClassName="FormModal__saveButton_content"
          backClassName="FormModal__saveButton_content"
          workingIconClassName="FormModal__saveButton_icon"
          label={props.downloadButtonLabel}
          usePropState={true}
          mode={mode}
          onClick={props.onDownload}
        />
      </ModalFooter>
    </Modal>
  );
}

BaseExportModalHOCView.propTypes = {
  format: T.string.isRequired,

  onChangeFormatXlsx: T.func,
  onChangeFormatCsv: T.func,
  onReset: T.func,
  onDownload: T.func,
  onClose: T.func,
  onSubmit: T.func,

  status: T.string,
  showSuccess: T.bool,

  headerLabel: T.string.isRequired,
  formatHeaderLabel: T.string,
  formatXlsxLabel: T.string,
  formatCsvLabel: T.string,
  downloadButtonLabel: T.string,
  resetButtonLabel: T.string,
  closeButtonLabel: T.string,
};

BaseExportModalHOCView.defaultProps = {
  className: '',
};

export const ExportModalHOCView = I18nComponent(BaseExportModalHOCView, [
  {code: 'default.button.download.label', prop: 'downloadButtonLabel'},
  {code: 'default.button.reset.label', prop: 'resetButtonLabel'},
  {code: 'default.close.label', prop: 'closeButtonLabel'},
]);

function getHeaderLabel(props) {
  return {
    code: props.headerLabel,
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/components/ExportModalHOC/ExportModalHOCView.js